// extracted by mini-css-extract-plugin
export default {"clothesContainer":"ClothesBlock_clothesContainer__fzyNM","clothesBlock":"ClothesBlock_clothesBlock__hXZ2R","title":"ClothesBlock_title__wxYOR"};